/**
 * Ops-map presence / network labels — server ``map_pulse`` + ``map_presence`` only.
 */

/**
 * @param {number | null | undefined} sec
 * @returns {string}
 */
export function formatOpsMapSignalAge(sec) {
  const n = Number(sec);
  if (!Number.isFinite(n) || n < 0) return "无信号";
  if (n < 60) return `${Math.round(n)}s 前`;
  if (n < 3600) return `${Math.round(n / 60)}m 前`;
  return `${Math.round(n / 3600)}h 前`;
}

/**
 * @param {Record<string, unknown>} item
 * @returns {{ label: string; cls: string }}
 */
export function opsMapPresenceStatus(item) {
  const pulse = String(item.map_pulse || "").trim().toLowerCase();
  if (pulse === "alert") return { label: "警报", cls: "alert" };
  if (pulse === "online") return { label: "在线", cls: "online" };
  if (pulse === "offline") return { label: "离线", cls: "offline" };
  return item.is_online ? { label: "在线", cls: "online" } : { label: "离线", cls: "offline" };
}

/**
 * @param {Record<string, unknown>} item
 * @returns {string}
 */
export function opsMapNetworkSummary(item) {
  const mp = /** @type {Record<string, unknown> | undefined} */ (item.map_presence);
  if (mp && String(mp.net_summary || "").trim()) return String(mp.net_summary).trim();
  if (mp && String(mp.line || "").trim() && String(mp.line).trim() !== "—") {
    return String(mp.line).trim();
  }
  return "—";
}

/**
 * @param {Record<string, unknown>} item
 * @returns {string}
 */
export function opsMapPresenceTooltip(item) {
  const st = opsMapPresenceStatus(item);
  const net = opsMapNetworkSummary(item);
  const mp = /** @type {Record<string, unknown> | undefined} */ (item.map_presence);
  const hb = mp ? formatOpsMapSignalAge(/** @type {number} */ (mp.last_heartbeat_age_s)) : "";
  const sig = mp ? formatOpsMapSignalAge(/** @type {number} */ (mp.last_signal_age_s)) : "";
  return `${st.label} · ${net} · 心跳 ${hb} · 信号 ${sig}`;
}
